import ErrorIcon from '../Icon/ErrorIcon.js';
import WarningIcon from '../Icon/WarningIcon.js';

//
var script = {
  name: 'Header',
  components: {
    WarningIcon,
    ErrorIcon
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    appearance: {
      type: String,
      default: ''
    }
  },
  computed: {
    icon() {
      return this.appearance === 'danger' ? 'ErrorIcon' : 'WarningIcon';
    },

    color() {
      return this.appearance === 'danger' ? '#DE350B' : '#FF991F';
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Modal/Header.vue_rollup-plugin-vue=script.js